import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import VideoTile from 'components/VideoTile';

class HoverVideoTile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      initalRender: false,
    };
  }

  static getDerivedStateFromProps({ rendered }) {
    if (rendered) {
      return { initalRender: true };
    }
    return null;
  }

  render() {
    const { altText, rendered, renderImage, video, image, play } = this.props;
    const { initalRender } = this.state;
    if (!initalRender) return null;
    return (
      <span style={{ display: rendered ? 'block' : 'none' }}>
        <VideoTile
          altText={altText}
          data-test="tile-video"
          id={video ? `tile-video-${video}` : undefined}
          image={image}
          load
          loop
          play={play}
          renderImage={renderImage}
          timer={0}
          video={video}
        />
      </span>
    );
  }
}

HoverVideoTile.defaultProps = {
  altText: '',
  image: null,
  play: null,
  rendered: false,
  renderImage: () => {},
  video: null,
};

HoverVideoTile.propTypes = {
  altText: PropTypes.string,
  image: PropTypes.string,
  play: PropTypes.bool,
  rendered: PropTypes.bool,
  renderImage: PropTypes.func,
  video: PropTypes.string,
};

export default HoverVideoTile;
